import React, { Fragment } from 'react';
import { Col, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SubHeader from '../SubHeader/index';

import styles from './Header.module.scss';
import { ROUTER_BASE_PATH } from '../../constants/siteConstants';

const navbarMenu = [
  {
    id: 'persons',
    text: 'Personas',
    href: '/prepagaclientes/',
  },
  {
    id: 'company',
    text: 'Empresas',
    href: `/empresas/inicio`,
  },
  {
    id: 'vendors',
    text: 'Prestadores',
    href: `${ROUTER_BASE_PATH}/`,
  },
  {
    id: 'vendors',
    text: 'Proveedores',
    href: '/proveedores',
  },
  {
    id: 'rrhh',
    text: 'RRHH',
    href: 'https://career4.successfactors.com/career?company=swissmedicP',
  },
  {
    id: 'collaborators',
    text: 'Colaboradores',
    href: 'https://login.microsoftonline.com/login.srf?wa=wsignin1.0&whr=swissmedical.com.ar&wreply=https:%2f%2fswissmedicalgroup%2esharepoint%2ecom%2fsites%2fconectados%2fPaginas%2findex%2easpx',
  },
];

const Header = () => {
  return (
    <>
      <div className='col-12 d-none d-lg-flex d-xl-flex'>
        <Col
          className={`${styles.brand} d-none col-lg-3 col-xl-5 d-md-flex d-lg-flex d-xl-flex justify-content-center`}
        >
          <Link to={`/`}>
            <img
              src={`${process.env.PUBLIC_URL}/logo_smg.svg`}
              height='49'
              width='257'
              style={{ cursor: 'pointer' }}
              alt='Swiss Medical Group'
            />
          </Link>
        </Col>
        <Col className='col-lg-9 col-xl-7 d-none d-lg-flex d-xl-flex justify-content-center align-items-center'>
          <Nav>
            {navbarMenu.map((navItem, i, array) => {
              return (
                <Fragment key={i}>
                  <Nav.Item>
                    <Nav.Link
                      className={`${styles.headerText} `}
                      target='_blank'
                      href={navItem.href}
                    >
                      {navItem.text.toUpperCase()}
                    </Nav.Link>
                  </Nav.Item>
                  {array.length - 1 !== i && (
                    <Nav.Item>
                      <Nav.Link className={`${styles.headerSeparator}  `}>|</Nav.Link>
                    </Nav.Item>
                  )}
                </Fragment>
              );
            })}
          </Nav>
        </Col>
      </div>
      <SubHeader />
    </>
  );
};

export default Header;
